import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "11.999",
      height: "2",
      x: "2",
      y: "3",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "8",
      height: "2",
      x: "4",
      y: "7",
      rx: "1"
    }, null, -1),
    _createElementVNode("rect", {
      width: "4",
      height: "2",
      x: "6",
      y: "10.999",
      rx: "1"
    }, null, -1)
  ]))]))
}
export default { render: render }